import type { HashContent } from './controller/HashManager';
import { readEventMemory, writeEventMemory } from './eventMemory';

const STORAGE_KEY = 'racemap-player-favorites';

function isIdList(value: unknown): value is Array<string> {
  return Array.isArray(value) && value.every((id) => typeof id === 'string');
}

/** The favorite ids stored for this event; `[]` when nothing is stored. */
export function readFavorites(eventId: string): Array<string> {
  return readEventMemory(STORAGE_KEY, eventId, isIdList) ?? [];
}

/** Stores the favorite ids for this event. */
export function writeFavorites(eventId: string, selected: Array<string>): void {
  writeEventMemory(STORAGE_KEY, eventId, selected);
}

/**
 * The favorite ids the player should start with, or `null` when the url already carries a
 * selection and has to win — a shared link or an organizer's embed must show what it says, not
 * whatever this browser last looked at. `selectedStartNumber` counts as a selection too, because
 * it resolves into the very same `timer.selected`.
 */
export function getFavoritesToRestore(
  hash: Pick<HashContent, 'selected' | 'selectedStartNumber'>,
  eventId: string,
): Array<string> | null {
  if (hash.selected != null || hash.selectedStartNumber != null) return null;

  return readFavorites(eventId);
}
